<template>
  <div class="big">
    <DocMsg :isFlag="doc_msg" :doctorId="doctorId"></DocMsg>
    <div class="container">
      <div style="padding: 20px">
        <div class="searchbox">
          <div class="item">
            <span>患者姓名</span>
            <el-input
              placeholder="请输入"
              v-model="patient_name"
              style="width: 120px; margin-left: 12px"
              @input="search"
              clearable
            ></el-input>
          </div>
          <div class="item">
            <span>医生姓名</span>
            <el-input
              placeholder="请输入"
              v-model="doctor_name"
              style="width: 120px; margin-left: 12px"
              @input="search"
              clearable
            ></el-input>
          </div>
          <div class="item">
            <span>医生手机号</span>
            <el-input
              placeholder="请输入"
              v-model="doctor_phone"
              style="width: 120px; margin-left: 12px"
              clearable
              @input="search"
            ></el-input>
          </div>
          <div class="item">
            <span>云诊所名称</span>
            <el-input
              placeholder="请输入"
              v-model="org_name"
              style="width: 200px; margin-left: 12px"
              clearable
              @input="search"
            ></el-input>
          </div>
          <div class="item">
            <span style="margin-right: 8px">申请药房</span>
            <!-- <el-input
              placeholder="请输入"
              v-model="re_hospital"
              style="width: 200px; margin-left: 12px"
              clearable
              @input="search"
            ></el-input> -->
            <myInputSerch v-model="re_hospital" @update="search"></myInputSerch>
          </div>
          <div class="item">
            <span>开方时间</span>
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="~"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              @change="search"
              clearable
              style="width: 225px; margin-left: 12px"
            ></el-date-picker>
          </div>
          <div class="item">
            <span>来源</span>
            <el-select
              v-model="pre_type"
              placeholder="请选择"
              style="width: 260px; margin: 0 20px 0 10px"
              multiple
              clearable
              @change="search"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="item">
            <span>药品剂型</span>
            <el-select
              v-model="drug_type"
              placeholder="请选择"
              style="width: 150px; margin: 0 20px 0 10px"
              clearable
              @change="search"
            >
              <el-option
                v-for="item in options2"
                :key="item.drug_type"
                :label="item.drug_type_name"
                :value="item.drug_type"
              ></el-option>
            </el-select>
          </div>
          <div class="item">
            <span>是否隐藏剂量</span>
            <el-select
              v-model="is_show"
              placeholder="请选择"
              style="width: 150px; margin: 0 20px 0 10px"
              clearable
              @change="search"
            >
              <el-option
                v-for="item in options3"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>

          <div class="item">
            <span>处方号</span>
            <el-input
              placeholder="请输入"
              v-model="pre_id"
              style="width: 120px; margin-left: 12px"
              @input="search"
              clearable
            ></el-input>
          </div>
          
          <div class="item">
            <span style="margin-right: 10px">是否代煎</span>
            <span>
              <el-radio-group v-model="drug_machining" @change="search">
                <el-radio :label="0">全部</el-radio>
                <el-radio :label="1">代煎</el-radio>
                <el-radio :label="2">自煎</el-radio>
              </el-radio-group>
            </span>
            <el-button
              type="info"
              style="
                background-color: #eceff2;
                color: #747981;
                margin-left: 10px;
              "
              @click="search"
              >查询</el-button
            >
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              label="开方时间"
              prop="create_time"
            ></el-table-column>
            <el-table-column label="处方号" prop="pre_id"></el-table-column>

            <el-table-column label="患者信息">
              <template slot-scope="scope">
                <div>{{ scope.row.user_name }}</div>
                <div>
                  <span v-if="scope.row.patient_sex == 1">男</span>
                  <span v-if="scope.row.patient_sex == 2">女</span>
                  <span style="margin-left: 10px">{{ scope.row.age }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="科室"
              prop="department_name"
            ></el-table-column>
            <el-table-column label="医生信息">
              <template slot-scope="scope">
                <div
                  @click="showDocMsg(scope.row.doctor_id)"
                  style="cursor: pointer"
                >
                  {{ scope.row.doctor_name }}
                </div>
                <div>
                  <span v-if="scope.row.d_sex == 1">男</span>
                  <span v-if="scope.row.d_sex == 2">女</span>
                  <span style="margin-left: 10px">{{ scope.row.title }}</span>
                </div>
                <div>{{ scope.row.phone }}</div>
              </template>
            </el-table-column>
            <el-table-column label="药品剂型">
              <template slot-scope="scope">
                <div>{{ scope.row.drug_type_name }}</div>
                <div v-if="scope.row.drug_machining">代煎</div>
              </template>
            </el-table-column>

            <el-table-column
              label="药品金额"
              prop="drug_price"
            ></el-table-column>
            <el-table-column
              label="诊后管理费"
              prop="consult_drug_price"
            ></el-table-column>
            <el-table-column label="诊金">
              <template slot-scope="scope">
                <span>
                  {{
                    scope.row.consulting_gold == "0.00"
                      ? "免费"
                      : scope.row.consulting_gold
                  }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="是否隐藏剂量">
              <template slot-scope="scope">
                <span>{{ scope.row.is_show == 1 ? "否" : "是" }}</span>
              </template>
            </el-table-column>

            <el-table-column label="处方来源">
              <template slot-scope="scope">
                <span v-if="scope.row.pre_type == 1">问诊开方</span>
                <span v-if="scope.row.pre_type == 2">直接开方</span>
                <span v-if="scope.row.pre_type == 4">云诊所开方</span>
                <span v-if="scope.row.pre_type == 5">手机号开方</span>
                <span v-if="scope.row.pre_type == 6">微信开方</span>
                <span v-if="scope.row.pre_type == 7">视频问诊开方</span>
                <span v-if="scope.row.pre_type == 8">按方购药</span>
                <span v-if="scope.row.pre_type == 9">拍方购药</span>
                <div v-if="scope.row.org_name">{{ scope.row.org_name }}</div>
              </template>
            </el-table-column>

            <el-table-column label="申请时间" prop="f_time"></el-table-column>

            <el-table-column
              label="申请药房"
              prop="hospital_name"
            ></el-table-column>

            <el-table-column
              label="转单原因"
              prop="return_desc"
            ></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="toDetail(scope.row.pre_id)"
                  >查看处方</el-button
                >
                <el-button
                  type="text"
                  @click="distribution(scope.row)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('416')
                      : false
                  "
                  >分配</el-button
                >
                <el-button
                  type="text"
                  @click="rejectOrderHospital(scope.row.order_id)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1329')
                      : false
                  "
                  >驳回</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div style="margin-top: 24px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 分配药房 -->
    <el-dialog
      title="分配药房"
      :visible.sync="distributionShow"
      :close-on-click-modal="false"
      width="1200px"
      :before-close="
        () => {
          distributionShow = false;
        }
      "
      v-loading="loading"
    >
      <div class="dialog_content">
        <div class="left_box">
          <div class="title">当前订单信息</div>
          <div>
            <span>患者姓名：</span>
            <span style="margin-right: 20px">{{ order_info.user_name }}</span>
            <span>开方医生：</span>
            <span>{{ order_info.doctor_name }}</span>
          </div>
          <div>
            <span>处方类型：</span>
            <span style="margin-right: 20px">{{ order_info.type_name }}</span>
            <span>剂型：</span>
            <span>{{ order_info.drug_type_name }}</span>
            <span v-if="order_info.drug_machining == 1">(代煎)</span>
          </div>
          <div>
            <span>当前所在药房：</span>
            <span style="margin-right: 20px">{{
              order_info.hospital_name
            }}</span>
          </div>
          <div>
            <span>有无转单：</span>
            <span style="margin-right: 20px">{{ order_info.is_return }}</span>
          </div>
          <div v-if="order_info.drug_type_pid == 1">
            <span>支持药杯：</span>
            <span style="margin-right: 20px">{{ order_info.box }}</span>
          </div>
          <div>
            <span>收货信息：</span>
            <span style="margin-right: 20px">{{ order_info.address }}</span>
          </div>
          <div>
            <span>配送方式：</span>
            <span
              :style="{
                marginRight: '20px',
                color: order_info.delivery != 1 ? 'red' : '',
                fontSize: order_info.delivery != 1 ? '18px' : '14px',
                fontWeight: order_info.delivery != 1 ? 'bold' : 'normal',
              }"
              >{{ order_info.delivery | deliveryText }}</span
            >
          </div>
          <div>
            <span>客服备注：</span>
            <span style="margin-right: 20px">{{ order_info.doc_remark }}</span>
          </div>
          <div>
            <span>药房打印备注：</span>
            <span style="margin-right: 20px">{{
              order_info.hospital_print_remark
            }}</span>
          </div>
          <div>
            <span>订单备注：</span>
            <span style="margin-right: 20px">{{
              order_info.platform_hospital_remark
            }}</span>
          </div>
          <div style="margin-bottom: 15px">
            <span style="color: red">注：</span>
            <span>{{ notice }}</span>
          </div>
          <div class="title">患者待支付/待发货处方信息</div>
          <div class="prebox">
            <div v-for="(item, index) in pre_list" :key="index">
              <span>处方{{ index + 1 }}：</span>
              <span>{{ item.pre_id }}({{ item.order_status }})</span>
              <span style="margin: 0 14px">{{ item.type_name }}</span>
              <span>{{ item.hospital_name }}</span>
            </div>
          </div>
        </div>
        <div class="right_box">
          <div class="flex_between">
            <span>
              <span>药房名称</span>
              <el-input
                style="width: 140px; margin-left: 10px"
                v-model="search_hos"
                placeholder="请输入内容"
                @input="changeList"
                size="medium"
                clearable=""
              ></el-input>
            </span>
            <span v-if="show">建议：推荐不转单</span>
          </div>
          <div class="hospitalbox">
            <el-table
              ref="multipleTable"
              :data="hospitaList"
              tooltip-effect="dark"
              style="width: 100%"
              :header-cell-style="{ background: '#F5F5F5' }"
              height="555px"
            >
              <el-table-column prop="checked" width="30">
                <template slot-scope="scope">
                  <el-checkbox
                    v-model="scope.row.checked"
                    @change="
                      (val) => {
                        hospitalChange(val, scope.row);
                      }
                    "
                  ></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column label="药房名">
                <template slot-scope="scope">
                  <span>{{ scope.row.hospital_name }}</span>
                  <span v-if="scope.row.recommend == 1" class="tuijian"
                    >推荐</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                label="所在地区"
                prop="address"
              ></el-table-column>
              <el-table-column
                label="支持药杯/服用次数"
                v-if="order_info.drug_type == 1"
                prop="num_str"
              >
              </el-table-column>
              <el-table-column
                label="药品金额"
                prop="drug_price_str"
              ></el-table-column>
              <el-table-column
                label="加工费"
                prop="drug_machining_price"
                v-if="order_info.drug_machining == 1"
              ></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="distributionShow = false">取 消</el-button>
        <el-button type="primary" @click="distributionOrderHospitalBtn"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from "dayjs";
import myInputSerch from "@/components/myInputSerch";
import DocMsg from "../../../components/common/DocMsg.vue";
import common from "../../../api/common";
export default {
  data() {
    return {
      date: [],
      totalNum: 0,
      patient_name: "",
      doctor_name: "",
      doctor_phone: "",
      currentPage: 1,
      pagesize: 10,
      tableData: [],
      pre_type: [],
      drug_type: "",
      org_name: "",
      is_show: "",
      re_hospital: "",
      f_hospital: "",
      drug_machining: 0,
      pre_id: "",
      options: [
        {
          value: 1,
          label: "问诊开方",
        },
        {
          value: 2,
          label: "直接开方",
        },
        {
          value: 4,
          label: "云诊所开方",
        },
        {
          value: 5,
          label: "手机号开方",
        },
        {
          value: 6,
          label: "微信开方",
        },
        {
          value: 7,
          label: "视频问诊开方",
        },
        {
          value: 8,
          label: "按方购药",
        },
        {
          value: 9,
          label: "拍方购药",
        },
      ],
      options2: [],
      options3: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 0,
          label: "是",
        },
        {
          value: 1,
          label: "否",
        },
      ],
      item: {},
      distributionShow: false,
      order_info: {},
      hospitaList: [],
      hospitalData: [],
      pre_list: [],
      type_name: "",
      doc_msg: false,
      doctorId: "",
      search_hos: "",
      show: 1,
      confirm: 1,
      notice: "",
      loading: false,
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  components: {
    DocMsg,
    myInputSerch,
  },
  filters: {
    deliveryText(val) {
      switch (val) {
        case 1:
          return "快递";
        case 2:
          return "自提";
        case 3:
          return "闪送";
      }
    },
  },
  created() {
    this.getDrugTypeList();
  },
  activated() {
    this.getList();
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取处方列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        user_name: this.patient_name,
        doctor_name: this.doctor_name,
        doctor_phone: this.doctor_phone,
        pre_type: this.pre_type.toString(),
        drug_type: this.drug_type,
        org_name: this.org_name,
        is_show: this.is_show,
        is_return: 1,
        drug_machining: this.drug_machining,
        pre_id: this.pre_id,
        re_hospital: this.re_hospital,
      };
      if (this.date && this.date.length > 0) {
        data.create_start_time = dayjs(this.date[0]).format("YYYY-MM-DD");
        data.create_end_time = dayjs(this.date[1]).format("YYYY-MM-DD");
      }
      this.axios.post("platform/Order/getReturnOrder", data).then((res) => {
        if (!res.data.list.length && this.currentPage > 1) {
          this.currentPage = this.currentPage - 1;
          this.getList();
        }
        this.tableData = res.data.list.map((item) => {
          item.create_time = dayjs
            .unix(item.create_time)
            .format("YYYY-MM-DD HH:mm");
          if (item.f_time) {
            item.f_time = dayjs.unix(item.f_time).format("YYYY-MM-DD HH:mm");
          }
          return item;
        });
        this.totalNum = res.data.total;
      });
    },
    //获取平台开方可以选择的剂型列表
    getDrugTypeList() {
      let platform_type = 3;
      this.axios
        .post("platform/photograph/getDrugTypeList", { platform_type })
        .then((res) => {
          this.options2 = res.data.list;
        });
    },
    //查看详情
    toDetail(pre_id) {
      this.$router.push({
        path: "chufangdetail",
        query: {
          pre_id,
        },
      });
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //翻页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    distribution(item) {
      this.item = item;
      this.search_hos = "";
      this.getreturnhospitalist();
      this.distributionShow = true;
    },
    changeList(value) {
      if (value) {
        let arr = [];
        this.hospitalData.map((item) => {
          if (item.hospital_name.indexOf(value) != -1) {
            arr.push(item);
          }
        });
        this.hospitaList = arr;
      } else {
        this.hospitaList = this.hospitalData;
      }
    },
    //可分配药房列表
    getreturnhospitalist() {
      this.loading = true;
      let pre_id = this.item.pre_id;
      this.axios
        .post("platform/Order/getReturnHospitaList", { pre_id })
        .then((res) => {
          this.order_info = res.data.order_info;
          this.pre_list = res.data.pre_list;
          this.notice = res.data.notice;
          this.show = res.data.show;
          this.confirm = res.data.confirm;
          this.hospitalData = res.data.hospital.map((item) => {
            item.checked = false;
            if (item.day_num) {
              let day_str = item.day_num.replace(/,/g, "或");
              let day_arr = day_str.split("&");
              let str_arr = [];
              day_arr.map((i) => {
                let arr = i.split("|");
                let str = arr[0] + "格药杯每剂分" + arr[1] + "服用";
                str_arr.push(str);
              });
              item.num_str = "支持" + str_arr.toString();
            }
            return item;
          });
          this.hospitaList = this.hospitalData;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //药方选择
    hospitalChange(val, row) {
      this.hospitaList.forEach((ele) => {
        ele.checked = false;
      });
      row.checked = val;
    },
    // 确定分配
    isRealStock(hospital) {
      let params = {
        order_id: this.item.order_id,
        hospital_id: hospital.hospital_id,
      };
      common.isRealStock(params).then((res) => {
        let { code, data } = res;
        if (data.status === 1) {
          this.$confirm(
            `处方中${data.generic_name}的库存不足，确定将当前订单转到${hospital.hospital_name}吗？`,
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
            }
          )
            .then(() => {
              let params = {
                order_id: this.order_info.order_id,
                hospital_id: hospital.hospital_id,
                hospital_name: hospital.hospital_name,
              };
              this.axios
                .post("platform/Order/distributionOrderHospital", params)
                .then(() => {
                  this.$message.success("分配成功");
                  this.getList();
                  this.distributionShow = false;
                });
            })
            .catch(() => {});
        } else {
          let params = {
            order_id: this.order_info.order_id,
            hospital_id: hospital.hospital_id,
            hospital_name: hospital.hospital_name,
          };
          this.axios
            .post("platform/Order/distributionOrderHospital", params)
            .then(() => {
              this.$message.success("分配成功");
              this.getList();
              this.distributionShow = false;
            });
        }
      });
    },
    distributionOrderHospital(hospital) {
      let params = {
        order_id: this.order_info.order_id,
        hospital_id: hospital.hospital_id,
        hospital_name: hospital.hospital_name,
      };
      this.axios
        .post("platform/Order/distributionOrderHospital", params)
        .then(() => {
          this.$message.success("分配成功");
          this.getList();
          this.distributionShow = false;
        });
    },
    //分配药房
    distributionOrderHospitalBtn() {
      let hospital = this.hospitaList.find((ele) => {
        return ele.checked == true;
      });
      if (!hospital) {
        this.$message.error("请选择分配的药房");
        return false;
      }
      if (hospital.drug_lack_str != "") {
        this.$confirm(
          `处方中${hospital.drug_lack_str}在${hospital.hospital_name}药房中缺药，确定要继续转单吗？`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          }
        )
          .then(() => {
            this.confirmFn(hospital);
          })
          .catch(() => {});
      } else {
        this.confirmFn(hospital);
      }
    },
    // 同个患者其他处方类型方法
    confirmFn(hospital) {
      if (this.confirm) {
        this.$confirm(
          `当前患者有其他处方类型的处方在当前药房，确定将当前订单分配到${hospital.hospital_name}吗？`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          }
        )
          .then(() => {
            if (hospital.open_saas_stock == 1) {
              this.isRealStock(hospital);
            } else {
              this.distributionOrderHospital(hospital);
            }
          })
          .catch(() => {});
      } else {
        if (hospital.open_saas_stock == 1) {
          this.isRealStock(hospital);
        } else {
          this.distributionOrderHospital(hospital);
        }
      }
    },
    //驳回分配
    rejectOrderHospital(order_id) {
      this.$confirm("驳回后当前处方将退回至申请药房,确定驳回吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.axios
            .post("platform/Order/rejectOrderHospital", { order_id })
            .then(() => {
              this.$message.success("分配处方已驳回");
              this.getList();
            });
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 200px);
}
.mydivider {
  margin: 0;
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 0px;
  .item {
    margin-right: 20px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
  }
}
.dialog_content {
  display: flex;
  justify-content: space-between;
  text-align: left;
  box-sizing: border-box;
  .title {
    font-weight: 700;
    font-size: 15px;
    margin-bottom: 6px;
  }
  .left_box {
    width: 450px;
    padding: 15px 15px 0;
    box-sizing: border-box;
    line-height: 24px;
  }
  .right_box {
    padding: 15px 15px 0;
    width: 750px;
    border-left: 1px solid #ccc;
    box-sizing: border-box;
  }
  .prebox {
    border: 1px solid #ccc;
    padding: 10px;
    line-height: 30px;
    height: 300px;
    overflow: hidden;
    overflow-y: scroll;
  }
  .box {
    max-height: 300px;
    overflow: auto;
    padding: 0 10px;
  }
  .hospitalbox {
    border: 1px solid #ccc;
    margin-top: 20px;
  }
  .el-checkbox {
    margin-right: 15px;
  }
}
.tuijian {
  color: red;
  display: inline-block;
  font-size: 10px;
  border: 1px solid red;
  padding: 0 3px;
  margin-left: 10px;
}
</style>
<style>
.el-dialog {
  margin-top: 10vh !important;
}
</style>
